import { createApp } from 'vue'

import ElementPlus from 'element-plus'
import VueApexCharts from 'vue3-apexcharts'
import FloatingVue from 'floating-vue'
import store from "./stores/store";

import App from './App.vue'

const app = createApp(App)

app.use(store)
app.use(ElementPlus)
app.use(VueApexCharts)
app.use(FloatingVue)
app.mount('#app')
